import { css } from 'styled-components';

const variables = css`
  :root {
    --dark-navy: #efe7da;
    --navy: #fbf7ef;
    --light-navy: #ffffff;
    --lightest-navy: #d9e1ef;
    --navy-shadow: rgba(36, 51, 80, 0.16);
    --dark-slate: #7b8799;
    --slate: #556279;
    --light-slate: #69758a;
    --lightest-slate: #182235;
    --white: #ffffff;
    --green: #2f6bff;
    --green-tint: rgba(47, 107, 255, 0.1);
    --pink: #e6805f;
    --blue: #7fa5ff;
    --icon-accent: #182235;
    --surface: rgba(255, 255, 255, 0.74);
    --surface-strong: rgba(255, 255, 255, 0.92);
    --surface-hover: rgba(255, 255, 255, 0.98);
    --surface-border: rgba(24, 34, 53, 0.09);
    --header-bg: rgba(251, 247, 239, 0.84);
    --paper-soft: #f2ebdf;
    --line: rgba(24, 34, 53, 0.09);
    --line-strong: rgba(24, 34, 53, 0.16);

    --font-sans: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 6px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
